var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5958_2442)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.25 9.53683C1.25 4.32259 3.43751 2.0879 4.16667 1.34302H15.8334C16.5626 2.0879 18.75 4.32259 18.75 9.53683C18.75 15.4959 13.0047 17.6939 10.088 18.4388C7.17134 17.6939 1.25 15.4959 1.25 9.53683Z",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99992 10.9945C11.6255 10.9945 12.9432 9.67672 12.9432 8.05119C12.9432 6.42567 11.6255 5.10791 9.99992 5.10791C8.3744 5.10791 7.05664 6.42567 7.05664 8.05119C7.05664 9.67672 8.3744 10.9945 9.99992 10.9945Z",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9155 16.3717C13.2506 17.4859 11.3882 18.1067 10.088 18.4387C8.76962 18.102 6.83732 17.4684 5.11548 16.3249C5.43514 15.8495 5.82473 15.4201 6.27461 15.0524C7.32597 14.1931 8.64206 13.7236 9.99992 13.7236C11.3578 13.7236 12.6739 14.1931 13.7252 15.0524C14.1899 15.4321 14.5901 15.8779 14.9155 16.3717Z",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5958_2442"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPp);
export default __webpack_public_path__ + "static/media/pp.dfecc098b83b5cee66f53d950047ce87.svg";
export { ForwardRef as ReactComponent };